import type { ReactElement } from 'react';
import { Link } from 'react-router';
import { MY_QUOTES_PATH } from '@/shared/config';
import { buttonVariants, cn } from '@/shared/ui';

/** 주문이 하나도 없을 때 — 내 견적 빈 안내와 같은 모양. 주문은 발행된 견적에서 시작하므로 내 견적으로 이끈다. */
export const MyOrderEmpty = (): ReactElement => (
  <div className="flex flex-col items-center gap-5 border-y border-foreground/10 px-5 py-20 text-center sm:py-24">
    <p
      aria-hidden
      className="flex items-center gap-2 text-[11px] leading-none font-semibold tracking-[0.18em] text-muted-foreground uppercase"
    >
      <span className="block h-px w-6 bg-brand-lime" />
      No orders yet
    </p>
    <div className="space-y-2">
      <p className="text-xl font-bold tracking-[-0.02em] sm:text-2xl">아직 주문한 내역이 없어요</p>
      <p className="text-sm text-muted-foreground">
        견적을 받은 뒤 주문하면 이곳에서 제작·배송 진행을 확인할 수 있어요.
      </p>
    </div>
    <Link to={MY_QUOTES_PATH} className={cn(buttonVariants({ size: 'lg' }), 'mt-2 h-12 px-8')}>
      내 견적 보기
    </Link>
  </div>
);
